import Vue from 'vue';
const value = {
    state: {
        values: [],
    },

    getters: {
        values(state) {
            return state.values;
        }
    },

    mutations: {
        getValues(state, payload) {
            state.values = payload;
        },
    },

    actions: {
        getValues(context, payload) {
            const url = 'values';
            Vue.prototype.$axios
                .get(url)
                .then(
                    (res) => {
                        context.commit('getValues', res.data);
                    },
                    (error) => {
                        console.log(error);
                    },
                );
        },
    },
}

export default value